import apiClient from 'apiClient';
import { SaveData } from 'utils/api/types';
import { clubDataMapper } from 'utils/api/admins/dataMapper';

export const fetchClubs = () => apiClient.get('/api/v1/broker-management/clubs/');

export const fetchClubDetails = async (clubId: string): Promise<any> => {
  const { data } = await apiClient.get(`/api/v1/broker-management/clubs/${clubId}`);
  const commissionTermsData = await apiClient.get(`/api/v1/broker-management/club/${clubId}/commission-terms`);

  return clubDataMapper.map({
    data: {
      ...data.data,
      commission_terms: commissionTermsData.data,
    },
    resources: data.resources,
  });
};

export const updateClub = (clubId: string, values: SaveData): Promise<any> =>
  apiClient.post(`/api/v1/broker-management/update-club/${clubId}`, values);
